<template lang="pug"></template>

<script>
export default {
    name: 'BotaoMonitoramento',
    componentOptions: {
        title: 'Monitoramento',
        actions: [
            [
                {
                    name: 'Monitoramento',
                    iconClass: 'lyra-icon lyra-arvore',
                    showView: false,
                    action: 'abrirMonitoramento',
                    route: 'Monitoramento',
                    nameTranslationKey: 'mensagens.menuLateral.monitoramento'
                }
            ]
        ]
    },

    methods: {
        abrirMonitoramento() {
            if (this.$route.name !== 'Monitoramento') {
                this.$router.push({ name: 'Monitoramento' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
